import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { isNonEmptyVariable } from "@/util/common_function";
import { Button, Form } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

export const MODE = { NEW: "NEW", EDIT: "EDIT" };

const MedicalInfoModal = ({
  show,
  handleCancel,
  formSubmit,
  selectMedicalInfo = null,
  bookingsFieldsEnabled = true,
  startingPoint = "",
}) => {
  const [form] = useForm();
  useEffect(() => {
    if (isNonEmptyVariable(selectMedicalInfo)) {
      form.setFieldsValue(selectMedicalInfo);
    } else {
      form.resetFields();
    }
  }, [selectMedicalInfo]);
  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const data = {
        ...values,
        serviceDate: isNonEmptyVariable(values?.serviceDate)
          ? values?.serviceDate?.format("MM/DD/YYYY")
          : null,
      };
      formSubmit(data);
      form.resetFields();
    });
  };
  function handleFormCancel() {
    handleCancel();
    form.resetFields();
  }
  return (
    <>
      <Modal
        show={show}
        header={`${selectMedicalInfo ? "VIEW" : "ADD"} Medical Information`}
        onHide={handleFormCancel}
        handleCancel={handleFormCancel}
        handleSubmit={handleSubmit}
        designPattern="ant"
        width="60%"
        footerActions={[
          <Button
            key="SUBMIT"
            onClick={handleFormCancel}
            disabled={!bookingsFieldsEnabled}
          >
            Close
          </Button>,
          <Button
            key="SUBMIT"
            onClick={handleSubmit}
            disabled={!bookingsFieldsEnabled}
          >
            Save
          </Button>,
        ]}
      >
        <FieldSecurityProvider
          entity={SCHEMA_NAME.MED_HISTORY_HR}
          startingPoint={startingPoint}
          bookingsFieldsEnabled={bookingsFieldsEnabled}
        >
          <Form form={form} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="medicalRecord"
                  formItemProps={{
                    name: "medicalRecord",
                    label: "Medical Record",
                  }}
                >
                  <TextField name="medicalRecord" id="medicalRecord" />
                </SecureFormItem>
              </StyledGridCol>
              <StyledGridCol span={12}>
                <SecureFormItem
                  fieldName="serviceDate"
                  formItemProps={{ name: "serviceDate", label: "Service Date" }}
                >
                  <CommonDatePicker
                    showTime={false}
                    format="MM/DD/YYYY"
                    name="serviceDate"
                    id="serviceDate"
                    disabled={!bookingsFieldsEnabled}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow>
              <StyledGridCol span={24}>
                <SecureFormItem
                  fieldName="comment"
                  formItemProps={{ name: "comment", label: "Comments" }}
                >
                  <TextField
                    inputType="textarea"
                    name="comment"
                    id="comment"
                    rows={3}
                  />
                </SecureFormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </FieldSecurityProvider>
      </Modal>
    </>
  );
};

export default MedicalInfoModal;
